const Form = () => {
    
    $('.wpcf7-form-control').on('focus', function () {
        $(this).closest('.form-item').addClass('focused');
    });

    $('.wpcf7-form-control').on('blur', function () {

        if ($(this).val() === '') {
            $(this).closest('.form-item').removeClass('focused');
        }
    });
};

export { Form };
